<template lang="pug">
  v-container#updates(fluid)
    v-layout.py-3.updates(row wrap
      v-if="updates"
    )
      v-container(xs-12 fluid)
        h1.form-title.dark-text Historial de actualizaciones
      v-container(xs-8 fluid)
        v-layout(column
          v-for="(update, index) in updates"
        )
          v-form.pt-4.pb-5
            v-layout(row wrap align-center fill-height)
              v-flex.px-3(xs3)
                v-text-field(
                  disabled
                  label="Última actualización"
                  :value="update.when"
                )
              v-flex.px-3(xs3)
                v-text-field(
                  disabled
                  label="Persona que actualizó"
                  :value="update.who"
                )
              v-flex.px-3(xs3)
                v-text-field(
                  disabled
                  label="Cambios"
                  :value="update.changes"
                )
              v-flex.px-3(xs3)
                v-text-field(
                  disabled
                  label="Comentario de la versión"
                  :value="update.comments"
                )
              //v-flex.px-3(xs2)
                a.dark-text(href="") Ver esta versión
          v-divider(v-if="index < updates.length - 1")
    v-layout.py-3(row wrap v-else)
      v-container(xs-12 fluid)
        h1.form-title.dark-text Historial de actualizaciones
        br
        p Aún no se han realizado ediciones o actualizaciones a este folio.

</template>

<script>
export default {
  name: "Updates",
  props: {},
  data() {
    return {
      updates: this.$store.state.record.updates
    };
  }
};
</script>

<style scoped lang="scss">
.updates {
  max-height: 300px;
  overflow: scroll;
}
</style>
